import { Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { PatientModel, UserModel } from '../core/api/models';
import { AuthService } from '../auth';
import {
  HealthCheckApiService,
  StaffApiService,
  SupervisorApiService,
} from '../core/api/services';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../shared/services/alert.service';
import { Utils } from '../core/utils';
import { PatientSessionService } from '../staff/home/patient-session.service';

@Component({
  selector: 'app-graphs-main',
  templateUrl: './graphs-main.component.html',
  styleUrl: './graphs-main.component.css',
  standalone: false,
})
export class GraphsMainComponent implements OnInit {
  patientID = input.required<string>();

  private destroyRef = inject(DestroyRef);

  selectedPatientID: number | null = null;

  filteredPatients: any[] = [];

  userInfo: UserModel | null = null;
  pageTitle: string | null = null;
  loading: boolean = false;
  openMenu: boolean = false;

  constructor(
    private authService: AuthService,
    private healthCheckApiService: HealthCheckApiService,
    private router: Router,
    private supervisorApiService: SupervisorApiService,
    private staffApiService: StaffApiService,
    private alertService: AlertService,
    protected patientSessionService: PatientSessionService,
    private activatedRoute: ActivatedRoute
  ) {
    console.log(
      'SupervisorMain PatientSessionService instance:',
      this.patientSessionService
    );
  }

  ngOnInit() {
    this.authService.user().subscribe((user) => (this.userInfo = user));

    this.activatedRoute.params.subscribe((params) => {
      this.patientID = params['patientID'];
      this.selectedPatientID = Number(this.patientID);

    });
  }

  isRouteActive(route: string): boolean {
    return this.router.url.includes(route);
  }

  onPatientSelected(event: any) {
    this.router.navigate(['/graphs', this.selectedPatientID]);
  }

  activated(comp: any) {
    this.pageTitle = comp.pageTitle || '&nbsp;';
    if (comp instanceof GraphsMainComponent) {
      let tComp = comp as GraphsMainComponent;
      tComp.userInfo = this.userInfo;
    }
  }

  switchToStaff() {
    const patientSession = this.patientSessionService.getPatientSession();
    this.router.navigate([
      '/staff/home/' + this.selectedPatientID + '/' + patientSession?.ID,
    ]);
  }

  switchToSessionList() {
    this.router.navigate(['/staff/' + this.selectedPatientID + '/sessions']);
  }

  backToOpto() {
    window.location.href = this.authService.getOptoURL() ?? '/';
  }
}
